<section class="guided-flow-pattern__content__description">
  {{ accountOwnerDescription }}
</section>
<section class="guided-flow-pattern__content__account-owner-buttons">
  <c11n-radio-group
    [groupId]="'accountOwnerOptions'"
    [variant]="'tiles'"
    [hasError]="hasError"
  >
    <ng-container *ngFor="let option of accountOwnerOptions">
      <div class="owner-option">
      <c11n-radio class="account-owner-options"
                  [labelText]="option.label"
                  [labelWeight]="'bold'"
                  [descriptiveLabel]="option.desc"
                  (stateChange)="handleSelectEvent($event)"
      >
        <input
          c11nRadioInput
          [(ngModel)]="selectedAccountOwnerType"
          id="{{option.id}}"
          type="radio"
          name="account-owner"
          [value]="option.value"
          [checked]="selectedAccountOwnerType === option.id"
        />
      </c11n-radio>
      </div>
    </ng-container>
  </c11n-radio-group>
</section>

<!--TODO: This is commented out for the time being because when a user comes into the guided-flow for the FIRST time, they shouldn't see the option to remove an owner-->
<!--TODO: When we're implementing the EDIT functionality, add this content back and add functionality-->
<!--<section class="guided-flow-pattern__content__remove-owner">-->
<!--  &lt;!&ndash;   Placeholder for remove owner button functionality   &ndash;&gt;-->
<!--  <p class="c11n-text-md c11n-link&#45;&#45;reinforced">-->
<!--    <a c11n-link [variant]="'primary-reinforced'" tabindex="0">Remove owner</a>-->
<!--  </p>-->
<!--</section>-->

